import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { PublicFile } from './-components/public-file'
import { PublicFolder } from './-components/public-folder'
import { PublicUpload } from './-components/public-upload'
import { linkAccess } from './-lib/access'
import { publicLinkQueryOptions } from './-query/query-options'

/**
 * The link's own node: the file it was made on, or the root of its folder —
 * or, for an upload link, the form that sends files into its folder.
 *
 * The layout renders this only once the link is open, so the read below is
 * the layout's own from the cache and never a second request.
 */
export const Route = createFileRoute('/s/$token/')({
	component: PublicLinkRoot
})

function PublicLinkRoot() {
	const { token } = Route.useParams()
	const access = linkAccess(useQuery(publicLinkQueryOptions(token)))

	if (access.state !== 'open') {
		return null
	}

	const { link } = access

	return (
		<div className='flex min-h-0 flex-1 flex-col'>
			{/* Anything but `upload` is the page it always was: an older
			    server answers with no `kind` at all while a release rolls out. */}
			{link.kind === 'upload' && (
				<PublicUpload link={link} token={token} />
			)}
			{link.kind !== 'upload' && link.node.kind === 'file' && (
				<PublicFile file={link.node} link={link} token={token} />
			)}
			{link.kind !== 'upload' && link.node.kind !== 'file' && (
				<PublicFolder link={link} nodeId={link.node.id} token={token} />
			)}
		</div>
	)
}
